import { render, staticRenderFns } from "./tableModel.vue?vue&type=template&id=8e6ffcbe&scoped=true&"
import script from "./tableModel.vue?vue&type=script&lang=js&"
export * from "./tableModel.vue?vue&type=script&lang=js&"
import style0 from "./tableModel.vue?vue&type=style&index=0&id=8e6ffcbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6ffcbe",
  null
  
)

export default component.exports